import { Directive, ElementRef, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[ui-figure-text-bold]',
})
export class UiFigureTextBoldDirective {
  @HostBinding('class') elClass = 'ui-figure-text-bold';
}
